import React from 'react';
import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useFormattedDuration } from 'modules/notes/common/components/Timer';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(0, 1),
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    position: 'relative'
  },
  overTimeIcon: {
    top: 0,
    right: 0,
    position: 'absolute',
    width: theme.spacing(1),
    height: theme.spacing(1),
    border: '4px solid transparent',
    borderTopColor: 'rgba(133, 109, 219, 1)',
    borderRightColor: 'rgba(133, 109, 219, 1)'
  }
}));

type WorkHoursCellProps = {
  actualDuration: number;
  scheduledDuration: number;
};

const WorkHoursCell: React.FC<WorkHoursCellProps> = ({
  actualDuration,
  scheduledDuration
}: WorkHoursCellProps) => {
  const classes = useStyles();

  const colorShade = () => {
    if (scheduledDuration > 0) {
      let opacity = actualDuration / scheduledDuration;
      opacity = opacity > 1 ? 1 : opacity;
      return `rgba(38, 210, 147, ${opacity})`;
    }
    return 'rgba(38, 210, 147, 0)';
  };

  const formattedDuration = useFormattedDuration({
    needsMask: true,
    duration: actualDuration ?? 0
  });

  return (
    <Box
      className={classes.container}
      sx={{
        backgroundColor: colorShade()
      }}
      data-testid={'work-hours-cell-container'}
    >
      {actualDuration > scheduledDuration && (
        <div
          className={classes.overTimeIcon}
          data-testid={'work-hours-cell-overtime'}
        />
      )}
      <Typography variant="caption">{formattedDuration}</Typography>
    </Box>
  );
};
export default React.memo(WorkHoursCell);
